import { IFCOpeningParseReport, IFCRoofSlabParseReport, IFCWallParseReport } from '@mutations'

// The IFC parse tasks end green even when single elements could not be imported; their report
// says which. These helpers turn the failures of a report into a warning, or null if there are
// none (or the backend sent no report).

const notImported = (count: number, singular: string, plural: string): string =>
  `${count} ${count === 1 ? `${singular} konnte` : `${plural} konnten`} nicht importiert werden`

const toWarning = (parts: string[]): string | null =>
  parts.length ? `${parts.join('. ')}. Bitte Modell kontrollieren.` : null

export const getWallParseWarning = (report?: IFCWallParseReport): string | null => {
  if (!report) return null
  const parts: string[] = []
  const withoutStorey = report.skipped.filter(item => item.reason === 'no_matching_storey').length
  if (withoutStorey > 0) {
    parts.push(
      `${withoutStorey} ${
        withoutStorey === 1 ? 'Wand konnte' : 'Wände konnten'
      } keinem Stockwerk zugeordnet werden`,
    )
  }
  if (report.openings_failed.length > 0) {
    parts.push(notImported(report.openings_failed.length, 'Öffnung', 'Öffnungen'))
  }
  return toWarning(parts)
}

/** Openings that failed or had no opening in the wall plane; already imported ones are fine. */
export const countFailedOpenings = (report?: IFCOpeningParseReport): number =>
  report
    ? report.failed.length +
      report.skipped.filter(item => item.reason === 'no_opening_in_wall_plane').length
    : 0

export const getOpeningParseWarning = (report?: IFCOpeningParseReport): string | null => {
  const failed = countFailedOpenings(report)
  return toWarning(failed > 0 ? [notImported(failed, 'Öffnung', 'Öffnungen')] : [])
}

export const getRoofSlabParseWarning = (report?: IFCRoofSlabParseReport): string | null => {
  const failed = report ? report.failed.length + report.empty.length : 0
  return toWarning(failed > 0 ? [notImported(failed, 'Dachfläche', 'Dachflächen')] : [])
}
